import { Link } from "react-router-dom";
import { Instagram, Facebook, MapPin, Phone, Mail, Clock } from "lucide-react";
import { CONTACT, LOGO } from "../data/site";
import { BookButton } from "./ui-kit";

export default function Footer() {
  return (
    <footer className="relative bg-black border-t border-white/10 pt-20 pb-10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-2 gap-10 items-end pb-16 border-b border-white/10">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-gold">Ready when you are</p>
            <h2 className="font-display text-5xl md:text-7xl uppercase text-white leading-[0.95] mt-4">
              Let's get<br />you started.
            </h2>
          </div>
          <div className="lg:text-right">
            <p className="text-lightgrey mb-6 max-w-md lg:ml-auto">Book your free intro today. We'll show you around, answer your questions, and help you take the first step.</p>
            <BookButton testid="footer-book">Book Your Free Intro</BookButton>
          </div>
        </div>

        <div className="grid md:grid-cols-4 gap-10 py-16">
          <div>
            <div className="mb-4">
              <img src={LOGO.wordmarkWhite} alt="Hybrid Fitness Collective" className="h-12 w-auto object-contain" />
            </div>
            <p className="text-sm text-white/50 leading-relaxed">Coached group fitness built for everyday people in Pictou County, Nova Scotia.</p>
          </div>

          <div>
            <h4 className="text-white font-bold uppercase text-sm tracking-wide mb-4">Explore</h4>
            <ul className="space-y-2 text-sm text-white/60">
              <li><Link to="/about" className="hover:text-gold transition">About</Link></li>
              <li><Link to="/what-is-hyrox" className="hover:text-gold transition">What is Hyrox?</Link></li>
              <li><Link to="/programs" className="hover:text-gold transition">Programs</Link></li>
              <li><Link to="/schedule" className="hover:text-gold transition">Schedule</Link></li>
              <li><Link to="/pricing" className="hover:text-gold transition">Pricing</Link></li>
              <li><Link to="/success-stories" className="hover:text-gold transition">Success Stories</Link></li>
              <li><Link to="/events" className="hover:text-gold transition">Events</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold uppercase text-sm tracking-wide mb-4">Get in touch</h4>
            <ul className="space-y-3 text-sm text-white/60">
              <li className="flex gap-2"><MapPin size={16} className="text-gold shrink-0 mt-0.5" />{CONTACT.address}</li>
              <li className="flex gap-2"><Phone size={16} className="text-gold shrink-0 mt-0.5" /><a href={`tel:${CONTACT.phone}`} className="hover:text-gold">{CONTACT.phone}</a></li>
              <li className="flex gap-2"><Mail size={16} className="text-gold shrink-0 mt-0.5" /><a href={`mailto:${CONTACT.email}`} className="hover:text-gold break-all">{CONTACT.email}</a></li>
              <li className="flex gap-2"><Clock size={16} className="text-gold shrink-0 mt-0.5" />{CONTACT.hoursShort}</li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold uppercase text-sm tracking-wide mb-4">Follow along</h4>
            <div className="flex gap-3">
              <a href={CONTACT.instagram} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center text-white hover:bg-gold hover:text-black hover:border-gold transition" data-testid="footer-instagram"><Instagram size={18} /></a>
              <a href={CONTACT.facebook} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center text-white hover:bg-gold hover:text-black hover:border-gold transition" data-testid="footer-facebook"><Facebook size={18} /></a>
            </div>
            <div className="mt-6 rounded-xl overflow-hidden border border-white/10 h-28">
              <iframe title="map" src={CONTACT.mapEmbed} className="w-full h-full grayscale opacity-80" loading="lazy" />
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-white/40">
          <p>© {new Date().getFullYear()} Hybrid Fitness Collective. All rights reserved.</p>
          <p>Serving New Glasgow · Stellarton · Trenton · Pictou</p>
        </div>
      </div>
    </footer>
  );
}
